var pet_breeds ={
  pet_breeds: {
    cat: {
      abyssinian: {
      txt_id: "abyssinian",
      name: "Abyssinian"
      },
      aegean: {
      txt_id: "aegean",
      name: "Aegean"
      },
      american_curl: {
      txt_id: "american_curl",
      name: "American curl"
      },
      american_bobtail: {
      txt_id: "american_bobtail",
      name: "American bobtail"
      },
      american_shorthair: {
      txt_id: "american_shorthair",
      name: "American shorthair"
      },
      american_wirehair: {
      txt_id: "american_wirehair",
      name: "American wirehair"
      },
      arabian_mau: {
      txt_id: "arabian_mau",
      name: "Arabian mau"
      },
      australian_mist: {
      txt_id: "australian_mist",
      name: "Australian mist"
      },
      asian: {
      txt_id: "asian",
      name: "Asian"
      },
      asian_semi_longhair: {
      txt_id: "asian_semi_longhair",
      name: "Asian semi longhair"
      },
      balinese: {
      txt_id: "balinese",
      name: "Balinese"
      },
      bambino: {
      txt_id: "bambino",
      name: "Bambino"
      },
      bengal: {
      txt_id: "bengal",
      name: "Bengal"
      },
      birman: {
      txt_id: "birman",
      name: "Birman"
      },
      bombay: {
      txt_id: "bombay",
      name: "Bombay"
      },
      brazilian_shorthair: {
      txt_id: "brazilian_shorthair",
      name: "Brazilian shorthair"
      },
      british_semi_longhair: {
      txt_id: "british_semi_longhair",
      name: "British semi longhair"
      },
      british_shorthair: {
      txt_id: "british_shorthair",
      name: "British shorthair"
      },
      british_longhair: {
      txt_id: "british_longhair",
      name: "British longhair"
      },
      burmese: {
      txt_id: "burmese",
      name: "Burmese"
      },
      burmilla: {
      txt_id: "burmilla",
      name: "Burmilla"
      },
      california_spangled: {
      txt_id: "california_spangled",
      name: "California spangled"
      },
      chantilly_tiffany: {
      txt_id: "chantilly_tiffany",
      name: "Chantilly tiffany"
      },
      chartreux: {
      txt_id: "chartreux",
      name: "Chartreux"
      },
      chausie: {
      txt_id: "chausie",
      name: "Chausie"
      },
      cheetoh: {
      txt_id: "cheetoh",
      name: "Cheetoh"
      },
      colorpoint_shorthair: {
      txt_id: "colorpoint_shorthair",
      name: "Colorpoint shorthair"
      },
      cornish_rex: {
      txt_id: "cornish_rex",
      name: "Cornish rex"
      },
      cymric_manx_longhair: {
      txt_id: "cymric_manx_longhair",
      name: "Cymric manx longhair"
      },
      cyprus: {
      txt_id: "cyprus",
      name: "Cyprus"
      },
      devon_rex: {
      txt_id: "devon_rex",
      name: "Devon rex"
      },
      donskoy_or_don_sphynx: {
      txt_id: "donskoy_or_don_sphynx",
      name: "Donskoy or don sphynx"
      },
      dragon_li: {
      txt_id: "dragon_li",
      name: "Dragon li"
      },
      dwarf_or_dwelf: {
      txt_id: "dwarf_or_dwelf",
      name: "Dwarf or dwelf"
      },
      egyptian_mau: {
      txt_id: "egyptian_mau",
      name: "Egyptian mau"
      },
      european_shorthair: {
      txt_id: "european_shorthair",
      name: "European shorthair"
      },
      exotic_shorthair: {
      txt_id: "exotic_shorthair",
      name: "Exotic shorthair"
      },
      foldex: {
      txt_id: "foldex",
      name: "Foldex"
      },
      german_rex: {
      txt_id: "german_rex",
      name: "German rex"
      },
      havana_brown: {
      txt_id: "havana_brown",
      name: "Havana brown"
      },
      highlander: {
      txt_id: "highlander",
      name: "Highlander"
      },
      himalayan: {
      txt_id: "himalayan",
      name: "Himalayan"
      },
      japanese_bobtail: {
      txt_id: "japanese_bobtail",
      name: "Japanese bobtail"
      },
      javanese: {
      txt_id: "javanese",
      name: "Javanese"
      },
      kurilian_bobtail: {
      txt_id: "kurilian_bobtail",
      name: "Kurilian bobtail"
      },
      khao_manee: {
      txt_id: "khao_manee",
      name: "Khao manee"
      },
      korat: {
      txt_id: "korat",
      name: "Korat"
      },
      korean_bobtail: {
      txt_id: "korean_bobtail",
      name: "Korean bobtail"
      },
      korn_ja: {
      txt_id: "korn_ja",
      name: "Korn ja"
      },
      laperm: {
      txt_id: "laperm",
      name: "Laperm"
      },
      lykoi: {
      txt_id: "lykoi",
      name: "Lykoi"
      },
      maine_coon: {
      txt_id: "maine_coon",
      name: "Maine coon"
      },
      manx: {
      txt_id: "manx",
      name: "Manx"
      },
      mekong_bobtail: {
      txt_id: "mekong_bobtail",
      name: "Mekong bobtail"
      },
      minskin: {
      txt_id: "minskin",
      name: "Minskin"
      },
      munchkin: {
      txt_id: "munchkin",
      name: "Munchkin"
      },
      nebelung: {
      txt_id: "nebelung",
      name: "Nebelung"
      },
      napoleon: {
      txt_id: "napoleon",
      name: "Napoleon"
      },
      norwegian_forest: {
      txt_id: "norwegian_forest",
      name: "Norwegian forest"
      },
      ocicat: {
      txt_id: "ocicat",
      name: "Ocicat"
      },
      ojos_azules: {
      txt_id: "ojos_azules",
      name: "Ojos azules"
      },
      oregon_rex: {
      txt_id: "oregon_rex",
      name: "Oregon rex"
      },
      oriental_bicolor: {
      txt_id: "oriental_bicolor",
      name: "Oriental bicolor"
      },
      oriental_shorthair: {
      txt_id: "oriental_shorthair",
      name: "Oriental shorthair"
      },
      oriental_longhair: {
      txt_id: "oriental_longhair",
      name: "Oriental longhair"
      },
      perfold: {
      txt_id: "perfold",
      name: "Perfold"
      },
      persian_modern: {
      txt_id: "persian_modern",
      name: "Persian modern"
      },
      persian_traditional: {
      txt_id: "persian_traditional",
      name: "Persian traditional"
      },
      peterbald: {
      txt_id: "peterbald",
      name: "Peterbald"
      },
      pixie_bob: {
      txt_id: "pixie_bob",
      name: "Pixie bob"
      },
      raas: {
      txt_id: "raas",
      name: "Raas"
      },
      ragamuffin: {
      txt_id: "ragamuffin",
      name: "Ragamuffin"
      },
      ragdoll: {
      txt_id: "ragdoll",
      name: "Ragdoll"
      },
      russian_blue: {
      txt_id: "russian_blue",
      name: "Russian blue"
      },
      russian_white: {
      txt_id: "russian_white",
      name: "Russian white"
      },
      sam_sawet: {
      txt_id: "sam_sawet",
      name: "Sam sawet"
      },
      savannah: {
      txt_id: "savannah",
      name: "Savannah"
      },
      scottish_fold: {
      txt_id: "scottish_fold",
      name: "Scottish fold"
      },
      selkirk_rex: {
      txt_id: "selkirk_rex",
      name: "Selkirk rex"
      },
      serengeti: {
      txt_id: "serengeti",
      name: "Serengeti"
      },
      serrade_petit: {
      txt_id: "serrade_petit",
      name: "Serrade petit"
      },
      siamese: {
      txt_id: "siamese",
      name: "Siamese"
      },
      siberian: {
      txt_id: "siberian",
      name: "Siberian"
      },
      singapura: {
      txt_id: "singapura",
      name: "Singapura"
      },
      snowshoe: {
      txt_id: "snowshoe",
      name: "Snowshoe"
      },
      sokoke: {
      txt_id: "sokoke",
      name: "Sokoke"
      },
      somali: {
      txt_id: "somali",
      name: "Somali"
      },
      sphynx: {
      txt_id: "sphynx",
      name: "Sphynx"
      },
      suphalak: {
      txt_id: "suphalak",
      name: "Suphalak"
      },
      thai: {
      txt_id: "thai",
      name: "Thai"
      },
      thai_lilac: {
      txt_id: "thai_lilac",
      name: "Thai lilac"
      },
      tonkinese: {
      txt_id: "tonkinese",
      name: "Tonkinese"
      },
      toyger: {
      txt_id: "toyger",
      name: "Toyger"
      },
      turkish_angora: {
      txt_id: "turkish_angora",
      name: "Turkish angora"
      },
      turkish_van: {
      txt_id: "turkish_van",
      name: "Turkish van"
      },
      ukrainian_levkoy: {
      txt_id: "ukrainian_levkoy",
      name: "Ukrainian levkoy"
      }
    },
    dog: {
      affenpinscher: {
      txt_id: "affenpinscher",
      name: "Affenpinscher"
      },
      afghan_hound: {
      txt_id: "afghan_hound",
      name: "Afghan hound"
      },
      afghan_shepherd: {
      txt_id: "afghan_shepherd",
      name: "Afghan shepherd"
      },
      aidi: {
      txt_id: "aidi",
      name: "Aidi"
      },
      airedale_terrier: {
      txt_id: "airedale_terrier",
      name: "Airedale terrier"
      },
      akbash: {
      txt_id: "akbash",
      name: "Akbash"
      },
      akita_inu: {
      txt_id: "akita_inu",
      name: "Akita inu"
      },
      alano_espanol: {
      txt_id: "alano_espanol",
      name: "Alano espanol"
      },
      alaskan_klee_kai: {
      txt_id: "alaskan_klee_kai",
      name: "Alaskan klee kai"
      },
      alaskan_malamute: {
      txt_id: "alaskan_malamute",
      name: "Alaskan malamute"
      },
      alpine_dachsbracke: {
      txt_id: "alpine_dachsbracke",
      name: "Alpine dachsbracke"
      },
      alpine_spaniel: {
      txt_id: "alpine_spaniel",
      name: "Alpine spaniel"
      },
      american_akita: {
      txt_id: "american_akita",
      name: "American akita"
      },
      american_bulldog: {
      txt_id: "american_bulldog",
      name: "American bulldog"
      },
      american_cocker_spaniel: {
      txt_id: "american_cocker_spaniel",
      name: "American cocker spaniel"
      },
      american_english_coonhound: {
      txt_id: "american_english_coonhound",
      name: "American english coonhound"
      },
      american_eskimo_dog: {
      txt_id: "american_eskimo_dog",
      name: "American eskimo dog"
      },
      american_foxhound: {
      txt_id: "american_foxhound",
      name: "American foxhound"
      },
      american_hairless_terrier: {
      txt_id: "american_hairless_terrier",
      name: "American hairless terrier"
      },
      american_pit_bull_terrier: {
      txt_id: "american_pit_bull_terrier",
      name: "American pit bull terrier"
      },
      american_staffordshire_terrier: {
      txt_id: "american_staffordshire_terrier",
      name: "American staffordshire terrier"
      },
      american_water_spaniel: {
      txt_id: "american_water_spaniel",
      name: "American water spaniel"
      },
      anatolian_shepherd_dog: {
      txt_id: "anatolian_shepherd_dog",
      name: "Anatolian shepherd dog"
      },
      andalusian_hound: {
      txt_id: "andalusian_hound",
      name: "Andalusian hound"
      },
      anglo_francais_de_petite_venerie: {
      txt_id: "anglo_francais_de_petite_venerie",
      name: "Anglo francais de petite venerie"
      },
      appenzeller_sennenhund: {
      txt_id: "appenzeller_sennenhund",
      name: "Appenzeller sennenhund"
      },
      ariege_pointer: {
      txt_id: "ariege_pointer",
      name: "Ariege pointer"
      },
      ariegeois: {
      txt_id: "ariegeois",
      name: "Ariegeois"
      },
      armant: {
      txt_id: "armant",
      name: "Armant"
      },
      armenian_gampr_dog: {
      txt_id: "armenian_gampr_dog",
      name: "Armenian gampr dog"
      },
      artois_hound: {
      txt_id: "artois_hound",
      name: "Artois hound"
      },
      australian_cattle_dog: {
      txt_id: "australian_cattle_dog",
      name: "Australian cattle dog"
      },
      australian_kelpie: {
      txt_id: "australian_kelpie",
      name: "Australian kelpie"
      },
      australian_shepherd: {
      txt_id: "australian_shepherd",
      name: "Australian shepherd"
      },
      australian_silky_terrier: {
      txt_id: "australian_silky_terrier",
      name: "Australian silky terrier"
      },
      australian_stumpy_tail_cattle_do: {
      txt_id: "australian_stumpy_tail_cattle_do",
      name: "Australian stumpy tail cattle do"
      },
      australian_terrier: {
      txt_id: "australian_terrier",
      name: "Australian terrier"
      },
      austrian_black_and_tan_hound: {
      txt_id: "austrian_black_and_tan_hound",
      name: "Austrian black and tan hound"
      },
      austrian_pinscher: {
      txt_id: "austrian_pinscher",
      name: "Austrian pinscher"
      },
      azawakh: {
      txt_id: "azawakh",
      name: "Azawakh"
      },
      bakharwal_dog: {
      txt_id: "bakharwal_dog",
      name: "Bakharwal dog"
      },
      barbet: {
      txt_id: "barbet",
      name: "Barbet"
      },
      basenji: {
      txt_id: "basenji",
      name: "Basenji"
      },
      basque_ratter: {
      txt_id: "basque_ratter",
      name: "Basque ratter"
      },
      basque_shepherd_dog: {
      txt_id: "basque_shepherd_dog",
      name: "Basque shepherd dog"
      },
      basset_artesien_normand: {
      txt_id: "basset_artesien_normand",
      name: "Basset artesien normand"
      },
      basset_bleu_de_gascogne: {
      txt_id: "basset_bleu_de_gascogne",
      name: "Basset bleu de gascogne"
      },
      basset_fauve_de_bretagne: {
      txt_id: "basset_fauve_de_bretagne",
      name: "Basset fauve de bretagne"
      },
      basset_griffon_vendeen: {
      txt_id: "basset_griffon_vendeen",
      name: "Basset griffon vendeen"
      },
      basset_hound: {
      txt_id: "basset_hound",
      name: "Basset hound"
      },
      bavarian_mountain_hound: {
      txt_id: "bavarian_mountain_hound",
      name: "Bavarian mountain hound"
      },
      beagle: {
      txt_id: "beagle",
      name: "Beagle"
      },
      beagle_harrier: {
      txt_id: "beagle_harrier",
      name: "Beagle harrier"
      },
      bearded_collie: {
      txt_id: "bearded_collie",
      name: "Bearded collie"
      },
      beauceron: {
      txt_id: "beauceron",
      name: "Beauceron"
      },
      bedlington_terrier: {
      txt_id: "bedlington_terrier",
      name: "Bedlington terrier"
      },
      belgian_shepherd_tervuren: {
      txt_id: "belgian_shepherd_tervuren",
      name: "Belgian shepherd tervuren"
      },
      belgian_shepherd_dog_groenendael: {
      txt_id: "belgian_shepherd_dog_groenendael",
      name: "Belgian shepherd dog groenendael"
      },
      belgian_shepherd_dog_laekenois: {
      txt_id: "belgian_shepherd_dog_laekenois",
      name: "Belgian shepherd dog laekenois"
      },
      belgian_shepherd_dog_malinois: {
      txt_id: "belgian_shepherd_dog_malinois",
      name: "Belgian shepherd dog malinois"
      },
      bergamasco_shepherd: {
      txt_id: "bergamasco_shepherd",
      name: "Bergamasco shepherd"
      },
      berger_blanc_suisse: {
      txt_id: "berger_blanc_suisse",
      name: "Berger blanc suisse"
      },
      berger_picard: {
      txt_id: "berger_picard",
      name: "Berger picard"
      },
      berner_laufhund: {
      txt_id: "berner_laufhund",
      name: "Berner laufhund"
      },
      bernese_mountain_dog: {
      txt_id: "bernese_mountain_dog",
      name: "Bernese mountain dog"
      },
      bichon_frise: {
      txt_id: "bichon_frise",
      name: "Bichon frise"
      },
      billy: {
      txt_id: "billy",
      name: "Billy"
      },
      black_and_tan_coonhound: {
      txt_id: "black_and_tan_coonhound",
      name: "Black and tan coonhound"
      },
      black_and_tan_virginia_foxhound: {
      txt_id: "black_and_tan_virginia_foxhound",
      name: "Black and tan virginia foxhound"
      },
      black_norwegian_elkhound: {
      txt_id: "black_norwegian_elkhound",
      name: "Black norwegian elkhound"
      },
      black_russian_terrier: {
      txt_id: "black_russian_terrier",
      name: "Black russian terrier"
      },
      blackmouth_cur: {
      txt_id: "blackmouth_cur",
      name: "Blackmouth cur"
      },
      bleu_de_gascogne: {
      txt_id: "bleu_de_gascogne",
      name: "Bleu de gascogne"
      },
      bloodhound: {
      txt_id: "bloodhound",
      name: "Bloodhound"
      },
      blue_heeler: {
      txt_id: "blue_heeler",
      name: "Blue heeler"
      },
      blue_lacy: {
      txt_id: "blue_lacy",
      name: "Blue lacy"
      },
      blue_paul_terrier: {
      txt_id: "blue_paul_terrier",
      name: "Blue paul terrier"
      },
      bluetick_coonhound: {
      txt_id: "bluetick_coonhound",
      name: "Bluetick coonhound"
      },
      boerboel: {
      txt_id: "boerboel",
      name: "Boerboel"
      },
      bohemian_shepherd: {
      txt_id: "bohemian_shepherd",
      name: "Bohemian shepherd"
      },
      bolognese: {
      txt_id: "bolognese",
      name: "Bolognese"
      },
      border_collie: {
      txt_id: "border_collie",
      name: "Border collie"
      },
      border_terrier: {
      txt_id: "border_terrier",
      name: "Border terrier"
      },
      borzoi: {
      txt_id: "borzoi",
      name: "Borzoi"
      },
      bosnian_coarse_haired_hound: {
      txt_id: "bosnian_coarse_haired_hound",
      name: "Bosnian coarse haired hound"
      },
      boston_terrier: {
      txt_id: "boston_terrier",
      name: "Boston terrier"
      },
      bouvier_des_ardennes: {
      txt_id: "bouvier_des_ardennes",
      name: "Bouvier des ardennes"
      },
      bouvier_des_flandres: {
      txt_id: "bouvier_des_flandres",
      name: "Bouvier des flandres"
      },
      boxer: {
      txt_id: "boxer",
      name: "Boxer"
      },
      boykin_spaniel: {
      txt_id: "boykin_spaniel",
      name: "Boykin spaniel"
      },
      bracco_italiano: {
      txt_id: "bracco_italiano",
      name: "Bracco italiano"
      },
      braque_dauvergne: {
      txt_id: "braque_dauvergne",
      name: "Braque dauvergne"
      },
      braque_du_bourbonnais: {
      txt_id: "braque_du_bourbonnais",
      name: "Braque du bourbonnais"
      },
      braque_du_puy: {
      txt_id: "braque_du_puy",
      name: "Braque du puy"
      },
      braque_francais: {
      txt_id: "braque_francais",
      name: "Braque francais"
      },
      braque_saint_germain: {
      txt_id: "braque_saint_germain",
      name: "Braque saint germain"
      },
      brazilian_dogo: {
      txt_id: "brazilian_dogo",
      name: "Brazilian dogo"
      },
      brazilian_terrier: {
      txt_id: "brazilian_terrier",
      name: "Brazilian terrier"
      },
      briard: {
      txt_id: "briard",
      name: "Briard"
      },
      briquet_griffon_vendeen: {
      txt_id: "briquet_griffon_vendeen",
      name: "Briquet griffon vendeen"
      },
      brittany: {
      txt_id: "brittany",
      name: "Brittany"
      },
      broholmer: {
      txt_id: "broholmer",
      name: "Broholmer"
      },
      bruno_jura_hound: {
      txt_id: "bruno_jura_hound",
      name: "Bruno jura hound"
      },
      bucovina_shepherd_dog: {
      txt_id: "bucovina_shepherd_dog",
      name: "Bucovina shepherd dog"
      },
      bull_and_terrier: {
      txt_id: "bull_and_terrier",
      name: "Bull and terrier"
      },
      bull_terrier: {
      txt_id: "bull_terrier",
      name: "Bull terrier"
      },
      bull_terrier_miniature: {
      txt_id: "bull_terrier_miniature",
      name: "Bull terrier miniature"
      },
      bulldog: {
      txt_id: "bulldog",
      name: "Bulldog"
      },
      bullenbeisser: {
      txt_id: "bullenbeisser",
      name: "Bullenbeisser"
      },
      bullmastiff: {
      txt_id: "bullmastiff",
      name: "Bullmastiff"
      },
      bully_kutta: {
      txt_id: "bully_kutta",
      name: "Bully kutta"
      },
      burgos_pointer: {
      txt_id: "burgos_pointer",
      name: "Burgos pointer"
      },
      cairn_terrier: {
      txt_id: "cairn_terrier",
      name: "Cairn terrier"
      },
      canaan_dog: {
      txt_id: "canaan_dog",
      name: "Canaan dog"
      },
      canadian_eskimo_dog: {
      txt_id: "canadian_eskimo_dog",
      name: "Canadian eskimo dog"
      },
      cane_corso: {
      txt_id: "cane_corso",
      name: "Cane corso"
      },
      cantabrian_water_dog: {
      txt_id: "cantabrian_water_dog",
      name: "Cantabrian water dog"
      },
      carolina_dog: {
      txt_id: "carolina_dog",
      name: "Carolina dog"
      },
      carpathian_shepherd_dog: {
      txt_id: "carpathian_shepherd_dog",
      name: "Carpathian shepherd dog"
      },
      catahoula_cur: {
      txt_id: "catahoula_cur",
      name: "Catahoula cur"
      },
      catalan_sheepdog: {
      txt_id: "catalan_sheepdog",
      name: "Catalan sheepdog"
      },
      caucasian_shepherd_dog: {
      txt_id: "caucasian_shepherd_dog",
      name: "Caucasian shepherd dog"
      },
      cavalier_king_charles_spaniel: {
      txt_id: "cavalier_king_charles_spaniel",
      name: "Cavalier king charles spaniel"
      },
      central_asian_shepherd_dog: {
      txt_id: "central_asian_shepherd_dog",
      name: "Central asian shepherd dog"
      },
      cesky_fousek: {
      txt_id: "cesky_fousek",
      name: "Cesky fousek"
      },
      cesky_terrier: {
      txt_id: "cesky_terrier",
      name: "Cesky terrier"
      },
      chesapeake_bay_retriever: {
      txt_id: "chesapeake_bay_retriever",
      name: "Chesapeake bay retriever"
      },
      chien_francais_blanc_et_noir: {
      txt_id: "chien_francais_blanc_et_noir",
      name: "Chien francais blanc et noir"
      },
      chien_francais_blanc_et_orange: {
      txt_id: "chien_francais_blanc_et_orange",
      name: "Chien francais blanc et orange"
      },
      chien_francais_tricolore: {
      txt_id: "chien_francais_tricolore",
      name: "Chien francais tricolore"
      },
      chien_gris: {
      txt_id: "chien_gris",
      name: "Chien gris"
      },
      chihuahua: {
      txt_id: "chihuahua",
      name: "Chihuahua"
      },
      chilean_fox_terrier: {
      txt_id: "chilean_fox_terrier",
      name: "Chilean fox terrier"
      },
      chinese_chongqing_dog: {
      txt_id: "chinese_chongqing_dog",
      name: "Chinese chongqing dog"
      },
      chinese_crested_dog: {
      txt_id: "chinese_crested_dog",
      name: "Chinese crested dog"
      },
      chinese_imperial_dog: {
      txt_id: "chinese_imperial_dog",
      name: "Chinese imperial dog"
      },
      chinook: {
      txt_id: "chinook",
      name: "Chinook"
      },
      chippiparai: {
      txt_id: "chippiparai",
      name: "Chippiparai"
      },
      chow_chow: {
      txt_id: "chow_chow",
      name: "Chow chow"
      },
      cierny_sery: {
      txt_id: "cierny_sery",
      name: "Cierny sery"
      },
      cirneco_delletna: {
      txt_id: "cirneco_delletna",
      name: "Cirneco delletna"
      },
      clumber_spaniel: {
      txt_id: "clumber_spaniel",
      name: "Clumber spaniel"
      },
      collie: {
      txt_id: "collie",
      name: "Collie"
      },
      combai: {
      txt_id: "combai",
      name: "Combai"
      },
      cordoba_fighting_dog: {
      txt_id: "cordoba_fighting_dog",
      name: "Cordoba fighting dog"
      },
      coton_de_tulear: {
      txt_id: "coton_de_tulear",
      name: "Coton de tulear"
      },
      cretan_hound: {
      txt_id: "cretan_hound",
      name: "Cretan hound"
      },
      croatian_sheepdog: {
      txt_id: "croatian_sheepdog",
      name: "Croatian sheepdog"
      },
      cumberland_sheepdog: {
      txt_id: "cumberland_sheepdog",
      name: "Cumberland sheepdog"
      },
      curly_coated_retriever: {
      txt_id: "curly_coated_retriever",
      name: "Curly coated retriever"
      },
      cursinu: {
      txt_id: "cursinu",
      name: "Cursinu"
      },
      czechoslovak_wolfdog: {
      txt_id: "czechoslovak_wolfdog",
      name: "Czechoslovak wolfdog"
      },
      cao_da_serra_de_aires: {
      txt_id: "cao_da_serra_de_aires",
      name: "Cao da serra de aires"
      },
      cao_de_castro_laboreiro: {
      txt_id: "cao_de_castro_laboreiro",
      name: "Cao de castro laboreiro"
      },
      cao_fila_de_sao_miguel: {
      txt_id: "cao_fila_de_sao_miguel",
      name: "Cao fila de sao miguel"
      },
      dachshund: {
      txt_id: "dachshund",
      name: "Dachshund"
      },
      dalmatian: {
      txt_id: "dalmatian",
      name: "Dalmatian"
      },
      dandie_dinmont_terrier: {
      txt_id: "dandie_dinmont_terrier",
      name: "Dandie dinmont terrier"
      },
      danish_swedish_farmdog: {
      txt_id: "danish_swedish_farmdog",
      name: "Danish swedish farmdog"
      },
      decker_rat_terrier: {
      txt_id: "decker_rat_terrier",
      name: "Decker rat terrier"
      },
      deutsche_bracke: {
      txt_id: "deutsche_bracke",
      name: "Deutsche bracke"
      },
      doberman_pinscher: {
      txt_id: "doberman_pinscher",
      name: "Doberman pinscher"
      },
      dogo_argentino: {
      txt_id: "dogo_argentino",
      name: "Dogo argentino"
      },
      dogo_cubano: {
      txt_id: "dogo_cubano",
      name: "Dogo cubano"
      },
      dogue_de_bordeaux: {
      txt_id: "dogue_de_bordeaux",
      name: "Dogue de bordeaux"
      },
      drentse_patrijshond: {
      txt_id: "drentse_patrijshond",
      name: "Drentse patrijshond"
      },
      drever: {
      txt_id: "drever",
      name: "Drever"
      },
      dunker: {
      txt_id: "dunker",
      name: "Dunker"
      },
      dutch_shepherd_dog: {
      txt_id: "dutch_shepherd_dog",
      name: "Dutch shepherd dog"
      },
      dutch_smoushond: {
      txt_id: "dutch_smoushond",
      name: "Dutch smoushond"
      },
      east_siberian_laika: {
      txt_id: "east_siberian_laika",
      name: "East siberian laika"
      },
      east_european_shepherd: {
      txt_id: "east_european_shepherd",
      name: "East european shepherd"
      },
      elo: {
      txt_id: "elo",
      name: "Elo"
      },
      english_cocker_spaniel: {
      txt_id: "english_cocker_spaniel",
      name: "English cocker spaniel"
      },
      english_foxhound: {
      txt_id: "english_foxhound",
      name: "English foxhound"
      },
      english_mastiff: {
      txt_id: "english_mastiff",
      name: "English mastiff"
      },
      english_setter: {
      txt_id: "english_setter",
      name: "English setter"
      },
      english_shepherd: {
      txt_id: "english_shepherd",
      name: "English shepherd"
      },
      english_springer_spaniel: {
      txt_id: "english_springer_spaniel",
      name: "English springer spaniel"
      },
      english_toy_terrier_black_and_tan: {
      txt_id: "english_toy_terrier_black_and_tan",
      name: "English toy terrier black and tan"
      },
      english_water_spaniel: {
      txt_id: "english_water_spaniel",
      name: "English water spaniel"
      },
      english_white_terrier: {
      txt_id: "english_white_terrier",
      name: "English white terrier"
      },
      entlebucher_mountain_dog: {
      txt_id: "entlebucher_mountain_dog",
      name: "Entlebucher mountain dog"
      },
      estonian_hound: {
      txt_id: "estonian_hound",
      name: "Estonian hound"
      },
      estrela_mountain_dog: {
      txt_id: "estrela_mountain_dog",
      name: "Estrela mountain dog"
      },
      eurasier: {
      txt_id: "eurasier",
      name: "Eurasier"
      },
      field_spaniel: {
      txt_id: "field_spaniel",
      name: "Field spaniel"
      },
      fila_brasileiro: {
      txt_id: "fila_brasileiro",
      name: "Fila brasileiro"
      },
      finnish_hound: {
      txt_id: "finnish_hound",
      name: "Finnish hound"
      },
      finnish_lapphund: {
      txt_id: "finnish_lapphund",
      name: "Finnish lapphund"
      },
      finnish_spitz: {
      txt_id: "finnish_spitz",
      name: "Finnish spitz"
      },
      flat_coated_retriever: {
      txt_id: "flat_coated_retriever",
      name: "Flat coated retriever"
      },
      fox_terrier_smooth: {
      txt_id: "fox_terrier_smooth",
      name: "Fox terrier smooth"
      },
      fox_terrier: {
      txt_id: "fox_terrier",
      name: "Fox terrier"
      },
      french_brittany: {
      txt_id: "french_brittany",
      name: "French brittany"
      },
      french_bulldog: {
      txt_id: "french_bulldog",
      name: "French bulldog"
      },
      french_spaniel: {
      txt_id: "french_spaniel",
      name: "French spaniel"
      },
      gaddi_dog: {
      txt_id: "gaddi_dog",
      name: "Gaddi dog"
      },
      galgo_espanol: {
      txt_id: "galgo_espanol",
      name: "Galgo espanol"
      },
      galician_cattle_dog: {
      txt_id: "galician_cattle_dog",
      name: "Galician cattle dog"
      },
      garafian_shepherd: {
      txt_id: "garafian_shepherd",
      name: "Garafian shepherd"
      },
      gascon_saintongeois: {
      txt_id: "gascon_saintongeois",
      name: "Gascon saintongeois"
      },
      georgian_shepherd_dog: {
      txt_id: "georgian_shepherd_dog",
      name: "Georgian shepherd dog"
      },
      german_longhaired_pointer: {
      txt_id: "german_longhaired_pointer",
      name: "German longhaired pointer"
      },
      german_pinscher: {
      txt_id: "german_pinscher",
      name: "German pinscher"
      },
      german_rough_haired_pointer: {
      txt_id: "german_rough_haired_pointer",
      name: "German rough haired pointer"
      },
      german_shepherd_dog: {
      txt_id: "german_shepherd_dog",
      name: "German shepherd dog"
      },
      german_shorthaired_pointer: {
      txt_id: "german_shorthaired_pointer",
      name: "German shorthaired pointer"
      },
      german_spaniel: {
      txt_id: "german_spaniel",
      name: "German spaniel"
      },
      german_spitz: {
      txt_id: "german_spitz",
      name: "German spitz"
      },
      german_wirehaired_pointer: {
      txt_id: "german_wirehaired_pointer",
      name: "German wirehaired pointer"
      },
      giant_schnauzer: {
      txt_id: "giant_schnauzer",
      name: "Giant schnauzer"
      },
      glen_of_imaal_terrier: {
      txt_id: "glen_of_imaal_terrier",
      name: "Glen of imaal terrier"
      },
      golden_retriever: {
      txt_id: "golden_retriever",
      name: "Golden retriever"
      },
      gordon_setter: {
      txt_id: "gordon_setter",
      name: "Gordon setter"
      },
      gran_mastin_de_borinquen: {
      txt_id: "gran_mastin_de_borinquen",
      name: "Gran mastin de borinquen"
      },
      grand_anglo_francais_blanc_et_noir: {
      txt_id: "grand_anglo_francais_blanc_et_noir",
      name: "Grand anglo francais blanc et noir"
      },
      grand_anglo_francais_blanc_et_orange: {
      txt_id: "grand_anglo_francais_blanc_et_orange",
      name: "Grand anglo francais blanc et orange"
      },
      grand_anglo_francais_tricolore: {
      txt_id: "grand_anglo_francais_tricolore",
      name: "Grand anglo francais tricolore"
      },
      grand_griffon_vendeen: {
      txt_id: "grand_griffon_vendeen",
      name: "Grand griffon vendeen"
      },
      great_dane: {
      txt_id: "great_dane",
      name: "Great dane"
      },
      great_pyrenees: {
      txt_id: "great_pyrenees",
      name: "Great pyrenees"
      },
      greater_swiss_mountain_dog: {
      txt_id: "greater_swiss_mountain_dog",
      name: "Greater swiss mountain dog"
      },
      greek_harehound: {
      txt_id: "greek_harehound",
      name: "Greek harehound"
      },
      greenland_dog: {
      txt_id: "greenland_dog",
      name: "Greenland dog"
      },
      greyhound: {
      txt_id: "greyhound",
      name: "Greyhound"
      },
      griffon_bleu_de_gascogne: {
      txt_id: "griffon_bleu_de_gascogne",
      name: "Griffon bleu de gascogne"
      },
      griffon_bruxellois: {
      txt_id: "griffon_bruxellois",
      name: "Griffon bruxellois"
      },
      griffon_fauve_de_bretagne: {
      txt_id: "griffon_fauve_de_bretagne",
      name: "Griffon fauve de bretagne"
      },
      griffon_nivernais: {
      txt_id: "griffon_nivernais",
      name: "Griffon nivernais"
      },
      guatemalan_dogo: {
      txt_id: "guatemalan_dogo",
      name: "Guatemalan dogo"
      },
      hamiltonstovare: {
      txt_id: "hamiltonstovare",
      name: "Hamiltonstovare"
      },
      hanover_hound: {
      txt_id: "hanover_hound",
      name: "Hanover hound"
      },
      hare_indian_dog: {
      txt_id: "hare_indian_dog",
      name: "Hare indian dog"
      },
      harrier: {
      txt_id: "harrier",
      name: "Harrier"
      },
      havanese: {
      txt_id: "havanese",
      name: "Havanese"
      },
      hawaiian_poi_dog: {
      txt_id: "hawaiian_poi_dog",
      name: "Hawaiian poi dog"
      },
      himalayan_sheepdog: {
      txt_id: "himalayan_sheepdog",
      name: "Himalayan sheepdog"
      },
      hokkaido_ken: {
      txt_id: "hokkaido_ken",
      name: "Hokkaido ken"
      },
      hortaya_borzaya: {
      txt_id: "hortaya_borzaya",
      name: "Hortaya borzaya"
      },
      hovawart: {
      txt_id: "hovawart",
      name: "Hovawart"
      },
      huntaway: {
      txt_id: "huntaway",
      name: "Huntaway"
      },
      hygenhund: {
      txt_id: "hygenhund",
      name: "Hygenhund"
      },
      ibizan_hound: {
      txt_id: "ibizan_hound",
      name: "Ibizan hound"
      },
      icelandic_sheepdog: {
      txt_id: "icelandic_sheepdog",
      name: "Icelandic sheepdog"
      },
      indian_pariah_dog: {
      txt_id: "indian_pariah_dog",
      name: "Indian pariah dog"
      },
      indian_spitz: {
      txt_id: "indian_spitz",
      name: "Indian spitz"
      },
      irish_red_and_white_setter: {
      txt_id: "irish_red_and_white_setter",
      name: "Irish red and white setter"
      },
      irish_setter: {
      txt_id: "irish_setter",
      name: "Irish setter"
      },
      irish_terrier: {
      txt_id: "irish_terrier",
      name: "Irish terrier"
      },
      irish_water_spaniel: {
      txt_id: "irish_water_spaniel",
      name: "Irish water spaniel"
      },
      irish_wolfhound: {
      txt_id: "irish_wolfhound",
      name: "Irish wolfhound"
      },
      istrian_coarse_haired_hound: {
      txt_id: "istrian_coarse_haired_hound",
      name: "Istrian coarse haired hound"
      },
      istrian_shorthaired_hound: {
      txt_id: "istrian_shorthaired_hound",
      name: "Istrian shorthaired hound"
      },
      italian_greyhound: {
      txt_id: "italian_greyhound",
      name: "Italian greyhound"
      },
      jack_russell_terrier: {
      txt_id: "jack_russell_terrier",
      name: "Jack russell terrier"
      },
      jagdterrier: {
      txt_id: "jagdterrier",
      name: "Jagdterrier"
      },
      japanese_chin: {
      txt_id: "japanese_chin",
      name: "Japanese chin"
      },
      japanese_spitz: {
      txt_id: "japanese_spitz",
      name: "Japanese spitz"
      },
      japanese_terrier: {
      txt_id: "japanese_terrier",
      name: "Japanese terrier"
      },
      jamthund: {
      txt_id: "jamthund",
      name: "Jamthund"
      },
      kai_ken: {
      txt_id: "kai_ken",
      name: "Kai ken"
      },
      kaikadi: {
      txt_id: "kaikadi",
      name: "Kaikadi"
      },
      kangal_dog: {
      txt_id: "kangal_dog",
      name: "Kangal dog"
      },
      kanni: {
      txt_id: "kanni",
      name: "Kanni"
      },
      karakachan_dog: {
      txt_id: "karakachan_dog",
      name: "Karakachan dog"
      },
      karelian_bear_dog: {
      txt_id: "karelian_bear_dog",
      name: "Karelian bear dog"
      },
      karst_shepherd: {
      txt_id: "karst_shepherd",
      name: "Karst shepherd"
      },
      keeshond: {
      txt_id: "keeshond",
      name: "Keeshond"
      },
      kerry_beagle: {
      txt_id: "kerry_beagle",
      name: "Kerry beagle"
      },
      kerry_blue_terrier: {
      txt_id: "kerry_blue_terrier",
      name: "Kerry blue terrier"
      },
      king_charles_spaniel: {
      txt_id: "king_charles_spaniel",
      name: "King charles spaniel"
      },
      king_shepherd: {
      txt_id: "king_shepherd",
      name: "King shepherd"
      },
      kintamani: {
      txt_id: "kintamani",
      name: "Kintamani"
      },
      kishu_ken: {
      txt_id: "kishu_ken",
      name: "Kishu ken"
      },
      komondor: {
      txt_id: "komondor",
      name: "Komondor"
      },
      kooikerhondje: {
      txt_id: "kooikerhondje",
      name: "Kooikerhondje"
      },
      koolie: {
      txt_id: "koolie",
      name: "Koolie"
      },
      korean_jindo_dog: {
      txt_id: "korean_jindo_dog",
      name: "Korean jindo dog"
      },
      kromfohrlander: {
      txt_id: "kromfohrlander",
      name: "Kromfohrlander"
      },
      kumaon_mastiff: {
      txt_id: "kumaon_mastiff",
      name: "Kumaon mastiff"
      },
      kunming_wolfdog: {
      txt_id: "kunming_wolfdog",
      name: "Kunming wolfdog"
      },
      kurī: {
      txt_id: "kurī",
      name: "Kurī"
      },
      kuvasz: {
      txt_id: "kuvasz",
      name: "Kuvasz"
      },
      kyi_leo: {
      txt_id: "kyi_leo",
      name: "Kyi leo"
      },
      labrador_husky: {
      txt_id: "labrador_husky",
      name: "Labrador husky"
      },
      labrador_retriever: {
      txt_id: "labrador_retriever",
      name: "Labrador retriever"
      },
      lagotto_romagnolo: {
      txt_id: "lagotto_romagnolo",
      name: "Lagotto romagnolo"
      },
      lakeland_terrier: {
      txt_id: "lakeland_terrier",
      name: "Lakeland terrier"
      },
      lancashire_heeler: {
      txt_id: "lancashire_heeler",
      name: "Lancashire heeler"
      },
      landseer: {
      txt_id: "landseer",
      name: "Landseer"
      },
      lapponian_herder: {
      txt_id: "lapponian_herder",
      name: "Lapponian herder"
      },
      leonberger: {
      txt_id: "leonberger",
      name: "Leonberger"
      },
      lhasa_apso: {
      txt_id: "lhasa_apso",
      name: "Lhasa apso"
      },
      lithuanian_hound: {
      txt_id: "lithuanian_hound",
      name: "Lithuanian hound"
      },
      longhaired_whippet: {
      txt_id: "longhaired_whippet",
      name: "Longhaired whippet"
      },
      lowchen: {
      txt_id: "lowchen",
      name: "Lowchen"
      },
      magyar_agar: {
      txt_id: "magyar_agar",
      name: "Magyar agar"
      },
      mahratta_greyhound: {
      txt_id: "mahratta_greyhound",
      name: "Mahratta greyhound"
      },
      majorca_ratter: {
      txt_id: "majorca_ratter",
      name: "Majorca ratter"
      },
      majorca_shepherd_dog: {
      txt_id: "majorca_shepherd_dog",
      name: "Majorca shepherd dog"
      },
      maltese: {
      txt_id: "maltese",
      name: "Maltese"
      },
      manchester_terrier: {
      txt_id: "manchester_terrier",
      name: "Manchester terrier"
      },
      maremma_sheepdog: {
      txt_id: "maremma_sheepdog",
      name: "Maremma sheepdog"
      },
      mcnab: {
      txt_id: "mcnab",
      name: "Mcnab"
      },
      mexican_hairless_dog: {
      txt_id: "mexican_hairless_dog",
      name: "Mexican hairless dog"
      },
      miniature_american_shepherd: {
      txt_id: "miniature_american_shepherd",
      name: "Miniature american shepherd"
      },
      miniature_australian_shepherd: {
      txt_id: "miniature_australian_shepherd",
      name: "Miniature australian shepherd"
      },
      miniature_fox_terrier: {
      txt_id: "miniature_fox_terrier",
      name: "Miniature fox terrier"
      },
      miniature_pinscher: {
      txt_id: "miniature_pinscher",
      name: "Miniature pinscher"
      },
      miniature_schnauzer: {
      txt_id: "miniature_schnauzer",
      name: "Miniature schnauzer"
      },
      miniature_shar_pei: {
      txt_id: "miniature_shar_pei",
      name: "Miniature shar pei"
      },
      mioritic: {
      txt_id: "mioritic",
      name: "Mioritic"
      },
      molossus: {
      txt_id: "molossus",
      name: "Molossus"
      },
      molossus_of_epirus: {
      txt_id: "molossus_of_epirus",
      name: "Molossus of epirus"
      },
      montenegrin_mountain_hound: {
      txt_id: "montenegrin_mountain_hound",
      name: "Montenegrin mountain hound"
      },
      moscow_watchdog: {
      txt_id: "moscow_watchdog",
      name: "Moscow watchdog"
      },
      moscow_water_dog: {
      txt_id: "moscow_water_dog",
      name: "Moscow water dog"
      },
      mountain_cur: {
      txt_id: "mountain_cur",
      name: "Mountain cur"
      },
      mucuchies: {
      txt_id: "mucuchies",
      name: "Mucuchies"
      },
      mudhol_hound: {
      txt_id: "mudhol_hound",
      name: "Mudhol hound"
      },
      mudi: {
      txt_id: "mudi",
      name: "Mudi"
      },
      murcian_ratter: {
      txt_id: "murcian_ratter",
      name: "Murcian ratter"
      },
      münsterlander: {
      txt_id: "münsterlander",
      name: "Münsterlander"
      },
      neapolitan_mastiff: {
      txt_id: "neapolitan_mastiff",
      name: "Neapolitan mastiff"
      },
      new_zealand_heading_dog: {
      txt_id: "new_zealand_heading_dog",
      name: "New zealand heading dog"
      },
      newfoundland: {
      txt_id: "newfoundland",
      name: "Newfoundland"
      },
      norfolk_spaniel: {
      txt_id: "norfolk_spaniel",
      name: "Norfolk spaniel"
      },
      norfolk_terrier: {
      txt_id: "norfolk_terrier",
      name: "Norfolk terrier"
      },
      norrbottenspets: {
      txt_id: "norrbottenspets",
      name: "Norrbottenspets"
      },
      north_country_beagle: {
      txt_id: "north_country_beagle",
      name: "North country beagle"
      },
      northern_inuit_dog: {
      txt_id: "northern_inuit_dog",
      name: "Northern inuit dog"
      },
      norwegian_buhund: {
      txt_id: "norwegian_buhund",
      name: "Norwegian buhund"
      },
      norwegian_elkhound: {
      txt_id: "norwegian_elkhound",
      name: "Norwegian elkhound"
      },
      norwegian_lundehund: {
      txt_id: "norwegian_lundehund",
      name: "Norwegian lundehund"
      },
      norwich_terrier: {
      txt_id: "norwich_terrier",
      name: "Norwich terrier"
      },
      nova_scotia_duck_tolling_retriever: {
      txt_id: "nova_scotia_duck_tolling_retriever",
      name: "Nova scotia duck tolling retriever"
      },
      old_croatian_sighthound: {
      txt_id: "old_croatian_sighthound",
      name: "Old croatian sighthound"
      },
      old_danish_pointer: {
      txt_id: "old_danish_pointer",
      name: "Old danish pointer"
      },
      old_english_sheepdog: {
      txt_id: "old_english_sheepdog",
      name: "Old english sheepdog"
      },
      old_english_terrier: {
      txt_id: "old_english_terrier",
      name: "Old english terrier"
      },
      old_german_shepherd_dog: {
      txt_id: "old_german_shepherd_dog",
      name: "Old german shepherd dog"
      },
      old_time_farm_shepherd: {
      txt_id: "old_time_farm_shepherd",
      name: "Old time farm shepherd"
      },
      olde_english_bulldogge: {
      txt_id: "olde_english_bulldogge",
      name: "Olde english bulldogge"
      },
      otterhound: {
      txt_id: "otterhound",
      name: "Otterhound"
      },
      pachon_navarro: {
      txt_id: "pachon_navarro",
      name: "Pachon navarro"
      },
      paisley_terrier: {
      txt_id: "paisley_terrier",
      name: "Paisley terrier"
      },
      pandikona: {
      txt_id: "pandikona",
      name: "Pandikona"
      },
      papillon: {
      txt_id: "papillon",
      name: "Papillon"
      },
      parson_russell_terrier: {
      txt_id: "parson_russell_terrier",
      name: "Parson russell terrier"
      },
      patterdale_terrier: {
      txt_id: "patterdale_terrier",
      name: "Patterdale terrier"
      },
      pekingese: {
      txt_id: "pekingese",
      name: "Pekingese"
      },
      perro_de_presa_canario: {
      txt_id: "perro_de_presa_canario",
      name: "Perro de presa canario"
      },
      perro_de_presa_mallorquin: {
      txt_id: "perro_de_presa_mallorquin",
      name: "Perro de presa mallorquin"
      },
      perro_fino_colombiano: {
      txt_id: "perro_fino_colombiano",
      name: "Perro fino colombiano"
      },
      peruvian_hairless_dog: {
      txt_id: "peruvian_hairless_dog",
      name: "Peruvian hairless dog"
      },
      phalene: {
      txt_id: "phalene",
      name: "Phalene"
      },
      pharaoh_hound: {
      txt_id: "pharaoh_hound",
      name: "Pharaoh hound"
      },
      phu_quoc_ridgeback_dog: {
      txt_id: "phu_quoc_ridgeback_dog",
      name: "Phu quoc ridgeback dog"
      },
      picardy_spaniel: {
      txt_id: "picardy_spaniel",
      name: "Picardy spaniel"
      },
      plott_hound: {
      txt_id: "plott_hound",
      name: "Plott hound"
      },
      podenco_canario: {
      txt_id: "podenco_canario",
      name: "Podenco canario"
      },
      pointer: {
      txt_id: "pointer",
      name: "Pointer"
      },
      poitevin: {
      txt_id: "poitevin",
      name: "Poitevin"
      },
      polish_greyhound: {
      txt_id: "polish_greyhound",
      name: "Polish greyhound"
      },
      polish_hound: {
      txt_id: "polish_hound",
      name: "Polish hound"
      },
      polish_hunting_dog: {
      txt_id: "polish_hunting_dog",
      name: "Polish hunting dog"
      },
      polish_lowland_sheepdog: {
      txt_id: "polish_lowland_sheepdog",
      name: "Polish lowland sheepdog"
      },
      polish_tatra_sheepdog: {
      txt_id: "polish_tatra_sheepdog",
      name: "Polish tatra sheepdog"
      },
      pomeranian: {
      txt_id: "pomeranian",
      name: "Pomeranian"
      },
      pont_audemer_spaniel: {
      txt_id: "pont_audemer_spaniel",
      name: "Pont audemer spaniel"
      },
      poodle: {
      txt_id: "poodle",
      name: "Poodle"
      },
      porcelaine: {
      txt_id: "porcelaine",
      name: "Porcelaine"
      },
      portuguese_podengo: {
      txt_id: "portuguese_podengo",
      name: "Portuguese podengo"
      },
      portuguese_pointer: {
      txt_id: "portuguese_pointer",
      name: "Portuguese pointer"
      },
      portuguese_water_dog: {
      txt_id: "portuguese_water_dog",
      name: "Portuguese water dog"
      },
      posavac_hound: {
      txt_id: "posavac_hound",
      name: "Posavac hound"
      },
      prazsky_krysarik: {
      txt_id: "prazsky_krysarik",
      name: "Prazsky krysarik"
      },
      pudelpointer: {
      txt_id: "pudelpointer",
      name: "Pudelpointer"
      },
      pug: {
      txt_id: "pug",
      name: "Pug"
      },
      puli: {
      txt_id: "puli",
      name: "Puli"
      },
      pumi: {
      txt_id: "pumi",
      name: "Pumi"
      },
      pungsan_dog: {
      txt_id: "pungsan_dog",
      name: "Pungsan dog"
      },
      pyrenean_mastiff: {
      txt_id: "pyrenean_mastiff",
      name: "Pyrenean mastiff"
      },
      pyrenean_shepherd: {
      txt_id: "pyrenean_shepherd",
      name: "Pyrenean shepherd"
      },
      rafeiro_do_alentejo: {
      txt_id: "rafeiro_do_alentejo",
      name: "Rafeiro do alentejo"
      },
      rajapalayam: {
      txt_id: "rajapalayam",
      name: "Rajapalayam"
      },
      rampur_greyhound: {
      txt_id: "rampur_greyhound",
      name: "Rampur greyhound"
      },
      rastreador_brasileiro: {
      txt_id: "rastreador_brasileiro",
      name: "Rastreador brasileiro"
      },
      rat_terrier: {
      txt_id: "rat_terrier",
      name: "Rat terrier"
      },
      ratonero_bodeguero_andaluz: {
      txt_id: "ratonero_bodeguero_andaluz",
      name: "Ratonero bodeguero andaluz"
      },
      ratonero_valenciano: {
      txt_id: "ratonero_valenciano",
      name: "Ratonero valenciano"
      },
      redbone_coonhound: {
      txt_id: "redbone_coonhound",
      name: "Redbone coonhound"
      },
      rhodesian_ridgeback: {
      txt_id: "rhodesian_ridgeback",
      name: "Rhodesian ridgeback"
      },
      rottweiler: {
      txt_id: "rottweiler",
      name: "Rottweiler"
      },
      russell_terrier: {
      txt_id: "russell_terrier",
      name: "Russell terrier"
      },
      russian_spaniel: {
      txt_id: "russian_spaniel",
      name: "Russian spaniel"
      },
      russian_toy: {
      txt_id: "russian_toy",
      name: "Russian toy"
      },
      russian_tracker: {
      txt_id: "russian_tracker",
      name: "Russian tracker"
      },
      russo_european_laika: {
      txt_id: "russo_european_laika",
      name: "Russo european laika"
      },
      saarlooswolfhond: {
      txt_id: "saarlooswolfhond",
      name: "Saarlooswolfhond"
      },
      sabueso_espanol: {
      txt_id: "sabueso_espanol",
      name: "Sabueso espanol"
      },
      saint_usuge_spaniel: {
      txt_id: "saint_usuge_spaniel",
      name: "Saint usuge spaniel"
      },
      sakhalin_husky: {
      txt_id: "sakhalin_husky",
      name: "Sakhalin husky"
      },
      saluki: {
      txt_id: "saluki",
      name: "Saluki"
      },
      samoyed: {
      txt_id: "samoyed",
      name: "Samoyed"
      },
      santal_hound: {
      txt_id: "santal_hound",
      name: "Santal hound"
      },
      sapsali: {
      txt_id: "sapsali",
      name: "Sapsali"
      },
      schapendoes: {
      txt_id: "schapendoes",
      name: "Schapendoes"
      },
      schillerstovare: {
      txt_id: "schillerstovare",
      name: "Schillerstovare"
      },
      schipperke: {
      txt_id: "schipperke",
      name: "Schipperke"
      },
      schweizer_laufhund: {
      txt_id: "schweizer_laufhund",
      name: "Schweizer laufhund"
      },
      schweizerischer_niederlaufhund: {
      txt_id: "schweizerischer_niederlaufhund",
      name: "Schweizerischer niederlaufhund"
      },
      scotch_collie: {
      txt_id: "scotch_collie",
      name: "Scotch collie"
      },
      scottish_deerhound: {
      txt_id: "scottish_deerhound",
      name: "Scottish deerhound"
      },
      scottish_terrier: {
      txt_id: "scottish_terrier",
      name: "Scottish terrier"
      },
      sealyham_terrier: {
      txt_id: "sealyham_terrier",
      name: "Sealyham terrier"
      },
      segugio_italiano: {
      txt_id: "segugio_italiano",
      name: "Segugio italiano"
      },
      seppala_siberian_sleddog: {
      txt_id: "seppala_siberian_sleddog",
      name: "Seppala siberian sleddog"
      },
      serbian_hound: {
      txt_id: "serbian_hound",
      name: "Serbian hound"
      },
      serbian_tricolour_hound: {
      txt_id: "serbian_tricolour_hound",
      name: "Serbian tricolour hound"
      },
      seskar_seal_dog: {
      txt_id: "seskar_seal_dog",
      name: "Seskar seal dog"
      },
      shar_pei: {
      txt_id: "shar_pei",
      name: "Shar pei"
      },
      shetland_sheepdog: {
      txt_id: "shetland_sheepdog",
      name: "Shetland sheepdog"
      },
      shiba_inu: {
      txt_id: "shiba_inu",
      name: "Shiba inu"
      },
      shih_tzu: {
      txt_id: "shih_tzu",
      name: "Shih tzu"
      },
      shikoku_ken: {
      txt_id: "shikoku_ken",
      name: "Shikoku ken"
      },
      shiloh_shepherd_dog: {
      txt_id: "shiloh_shepherd_dog",
      name: "Shiloh shepherd dog"
      },
      siberian_husky: {
      txt_id: "siberian_husky",
      name: "Siberian husky"
      },
      silken_windhound: {
      txt_id: "silken_windhound",
      name: "Silken windhound"
      },
      sinhala_hound: {
      txt_id: "sinhala_hound",
      name: "Sinhala hound"
      },
      skye_terrier: {
      txt_id: "skye_terrier",
      name: "Skye terrier"
      },
      sloughi: {
      txt_id: "sloughi",
      name: "Sloughi"
      },
      slovak_cuvac: {
      txt_id: "slovak_cuvac",
      name: "Slovak cuvac"
      },
      slovakian_rough_haired_pointer: {
      txt_id: "slovakian_rough_haired_pointer",
      name: "Slovakian rough haired pointer"
      },
      slovensky_kopov: {
      txt_id: "slovensky_kopov",
      name: "Slovensky kopov"
      },
      small_greek_domestic_dog: {
      txt_id: "small_greek_domestic_dog",
      name: "Small greek domestic dog"
      },
      smalandsstovare: {
      txt_id: "smalandsstovare",
      name: "Smalandsstovare"
      },
      soft_coated_wheaten_terrier: {
      txt_id: "soft_coated_wheaten_terrier",
      name: "Soft coated wheaten terrier"
      },
      south_russian_ovcharka: {
      txt_id: "south_russian_ovcharka",
      name: "South russian ovcharka"
      },
      southern_hound: {
      txt_id: "southern_hound",
      name: "Southern hound"
      },
      spanish_mastiff: {
      txt_id: "spanish_mastiff",
      name: "Spanish mastiff"
      },
      spanish_water_dog: {
      txt_id: "spanish_water_dog",
      name: "Spanish water dog"
      },
      spinone_italiano: {
      txt_id: "spinone_italiano",
      name: "Spinone italiano"
      },
      sporting_lucas_terrier: {
      txt_id: "sporting_lucas_terrier",
      name: "Sporting lucas terrier"
      },
      st_bernard: {
      txt_id: "st_bernard",
      name: "St bernard"
      },
      st_johnss_water_dog: {
      txt_id: "st_johnss_water_dog",
      name: "St johnss water dog"
      },
      stabyhoun: {
      txt_id: "stabyhoun",
      name: "Stabyhoun"
      },
      staffordshire_bull_terrier: {
      txt_id: "staffordshire_bull_terrier",
      name: "Staffordshire bull terrier"
      },
      standard_schnauzer: {
      txt_id: "standard_schnauzer",
      name: "Standard schnauzer"
      },
      stephens_cur: {
      txt_id: "stephens_cur",
      name: "Stephens cur"
      },
      styrian_coarse_haired_hound: {
      txt_id: "styrian_coarse_haired_hound",
      name: "Styrian coarse haired hound"
      },
      sussex_spaniel: {
      txt_id: "sussex_spaniel",
      name: "Sussex spaniel"
      },
      swedish_lapphund: {
      txt_id: "swedish_lapphund",
      name: "Swedish lapphund"
      },
      swedish_vallhund: {
      txt_id: "swedish_vallhund",
      name: "Swedish vallhund"
      },
      tahltan_bear_dog: {
      txt_id: "tahltan_bear_dog",
      name: "Tahltan bear dog"
      },
      taigan: {
      txt_id: "taigan",
      name: "Taigan"
      },
      taiwan_dog: {
      txt_id: "taiwan_dog",
      name: "Taiwan dog"
      },
      talbot: {
      txt_id: "talbot",
      name: "Talbot"
      },
      tamaskan_dog: {
      txt_id: "tamaskan_dog",
      name: "Tamaskan dog"
      },
      teddy_roosevelt_terrier: {
      txt_id: "teddy_roosevelt_terrier",
      name: "Teddy roosevelt terrier"
      },
      telomian: {
      txt_id: "telomian",
      name: "Telomian"
      },
      tennessee_treeing_brindle: {
      txt_id: "tennessee_treeing_brindle",
      name: "Tennessee treeing brindle"
      },
      tenterfield_terrier: {
      txt_id: "tenterfield_terrier",
      name: "Tenterfield terrier"
      },
      terceira_mastiff: {
      txt_id: "terceira_mastiff",
      name: "Terceira mastiff"
      },
      thai_bangkaew_dog: {
      txt_id: "thai_bangkaew_dog",
      name: "Thai bangkaew dog"
      },
      thai_ridgeback: {
      txt_id: "thai_ridgeback",
      name: "Thai ridgeback"
      },
      tibetan_mastiff: {
      txt_id: "tibetan_mastiff",
      name: "Tibetan mastiff"
      },
      tibetan_spaniel: {
      txt_id: "tibetan_spaniel",
      name: "Tibetan spaniel"
      },
      tibetan_terrier: {
      txt_id: "tibetan_terrier",
      name: "Tibetan terrier"
      },
      tornjak: {
      txt_id: "tornjak",
      name: "Tornjak"
      },
      tosa: {
      txt_id: "tosa",
      name: "Tosa"
      },
      toy_bulldog: {
      txt_id: "toy_bulldog",
      name: "Toy bulldog"
      },
      toy_fox_terrier: {
      txt_id: "toy_fox_terrier",
      name: "Toy fox terrier"
      },
      toy_manchester_terrier: {
      txt_id: "toy_manchester_terrier",
      name: "Toy manchester terrier"
      },
      toy_trawler_spaniel: {
      txt_id: "toy_trawler_spaniel",
      name: "Toy trawler spaniel"
      },
      transylvanian_hound: {
      txt_id: "transylvanian_hound",
      name: "Transylvanian hound"
      },
      treeing_cur: {
      txt_id: "treeing_cur",
      name: "Treeing cur"
      },
      treeing_walker_coonhound: {
      txt_id: "treeing_walker_coonhound",
      name: "Treeing walker coonhound"
      },
      trigg_hound: {
      txt_id: "trigg_hound",
      name: "Trigg hound"
      },
      tweed_water_spaniel: {
      txt_id: "tweed_water_spaniel",
      name: "Tweed water spaniel"
      },
      tyrolean_hound: {
      txt_id: "tyrolean_hound",
      name: "Tyrolean hound"
      },
      uruguayan_cimarron: {
      txt_id: "uruguayan_cimarron",
      name: "Uruguayan cimarron"
      },
      vanjari_hound: {
      txt_id: "vanjari_hound",
      name: "Vanjari hound"
      },
      villano_de_las_encartaciones: {
      txt_id: "villano_de_las_encartaciones",
      name: "Villano de las encartaciones"
      },
      vizsla: {
      txt_id: "vizsla",
      name: "Vizsla"
      },
      volpino_italiano: {
      txt_id: "volpino_italiano",
      name: "Volpino italiano"
      },
      weimaraner: {
      txt_id: "weimaraner",
      name: "Weimaraner"
      },
      welsh_corgi: {
      txt_id: "welsh_corgi",
      name: "Welsh corgi"
      },
      welsh_sheepdog: {
      txt_id: "welsh_sheepdog",
      name: "Welsh sheepdog"
      },
      welsh_springer_spaniel: {
      txt_id: "welsh_springer_spaniel",
      name: "Welsh springer spaniel"
      },
      welsh_terrier: {
      txt_id: "welsh_terrier",
      name: "Welsh terrier"
      },
      west_highland_white_terrier: {
      txt_id: "west_highland_white_terrier",
      name: "West highland white terrier"
      },
      west_siberian_laika: {
      txt_id: "west_siberian_laika",
      name: "West siberian laika"
      },
      westphalian_dachsbracke: {
      txt_id: "westphalian_dachsbracke",
      name: "Westphalian dachsbracke"
      },
      wetterhoun: {
      txt_id: "wetterhoun",
      name: "Wetterhoun"
      },
      whippet: {
      txt_id: "whippet",
      name: "Whippet"
      },
      white_shepherd: {
      txt_id: "white_shepherd",
      name: "White shepherd"
      },
      wirehaired_pointing_griffon: {
      txt_id: "wirehaired_pointing_griffon",
      name: "Wirehaired pointing griffon"
      },
      wirehaired_vizsla: {
      txt_id: "wirehaired_vizsla",
      name: "Wirehaired vizsla"
      },
      xiasi_dog: {
      txt_id: "xiasi_dog",
      name: "Xiasi dog"
      },
      yorkshire_terrier: {
      txt_id: "yorkshire_terrier",
      name: "Yorkshire terrier"
      },
      epagneul_bleu_de_picardie: {
      txt_id: "epagneul_bleu_de_picardie",
      name: "Epagneul bleu de picardie"
      },
      sarplaninac: {
      txt_id: "sarplaninac",
      name: "Sarplaninac"
      }
    }
  }
}

module.exports = pet_breeds
